var map = {
	"./DragAndDrop.svg": "dd75",
	"./EME.svg": "3da1",
	"./EPE.svg": "86ff",
	"./HR.svg": "a40a",
	"./HR_w.svg": "ccca",
	"./NZR.svg": "a637",
	"./OV.svg": "db8d",
	"./SWV.svg": "bb2e",
	"./Test_Video.mp4": "f470",
	"./ZR.png": "2471",
	"./ZR.svg": "7629",
	"./ZR_w.svg": "278c",
	"./ZV.svg": "de5a",
	"./eme/DWAbbildung.png": "d304",
	"./eme/DreiVierer.png": "cf4a",
	"./eme/FuenfPunkte.png": "71fb",
	"./eme/Gruppen/01.png": "1078",
	"./eme/Gruppen/02.png": "848d",
	"./eme/Gruppen/03.png": "5b78",
	"./eme/Gruppen/04.png": "e7a0",
	"./eme/Gruppen/05.png": "1300",
	"./eme/Gruppen/06.png": "e625",
	"./eme/Gruppen/07.png": "c749",
	"./eme/Gruppen/08.png": "3f03",
	"./eme/Gruppen/09.png": "a61d",
	"./eme/Gruppen/10.png": "5a2f",
	"./eme/Gruppen/11.png": "5a7d",
	"./eme/Gruppen/12.png": "7a9e",
	"./eme/Pfade/Miriam/01.png": "1109",
	"./eme/Pfade/Miriam/02.png": "c74e",
	"./eme/Pfade/Miriam/03.png": "6511",
	"./eme/Pfade/Miriam/04.png": "b560",
	"./eme/Pfade/Miriam/05.png": "1cf6",
	"./eme/Pfade/Miriam/06.png": "bd6b",
	"./eme/Pfade/Miriam/07.png": "be60",
	"./eme/Pfade/Miriam/08.png": "5e09",
	"./eme/Pfade/Miriam/09.png": "9abe",
	"./eme/Pfade/Miriam/10.png": "b178",
	"./eme/Pfade/Miriam/11.png": "84dd",
	"./eme/Pfade/Miriam/12.png": "5b4f",
	"./eme/Pfade/Miriam/13.png": "80fc",
	"./eme/Pfade/Nino/01.png": "d2d6",
	"./eme/Pfade/Nino/02.png": "639c",
	"./eme/Pfade/Nino/03.png": "69a8",
	"./eme/Pfade/Nino/04.png": "15eb",
	"./eme/Pfade/Nino/05.png": "b23a",
	"./eme/Pfade/Nino/06.png": "10be",
	"./eme/Pfade/Nino/07.png": "8b9e",
	"./eme/Pfade/Nino/08.png": "64ff",
	"./eme/Pfade/Nino/09.png": "b4e2",
	"./eme/Pfade/Nino/10.png": "67b4",
	"./eme/Pfade/Nino/11.png": "e2cf",
	"./eme/Pfade/Nino/12.png": "0b71",
	"./eme/Pfade/Nino/13.png": "18f6",
	"./eme/Schieberegler/Kernaufgaben/step0_Kernaufgaben.png": "ccac",
	"./eme/Schieberegler/Kernaufgaben/step1_Kernaufgaben.png": "f680",
	"./eme/Schieberegler/Kernaufgaben/step1_Kernaufgaben_animation.mp4": "2b76",
	"./eme/Schieberegler/Kernaufgaben/step1_Kernaufgaben_animation.webm": "0761",
	"./eme/Schieberegler/Kernaufgaben/step2_Kernaufgaben.png": "d838",
	"./eme/Schieberegler/Kernaufgaben/step2_Kernaufgaben_animation.mp4": "c494",
	"./eme/Schieberegler/Kernaufgaben/step2_Kernaufgaben_animation.webm": "9241",
	"./eme/Schieberegler/Kernaufgaben/step3_Kernaufgaben.png": "7382",
	"./eme/Schieberegler/Kernaufgaben/step3_Kernaufgaben_animation.mp4": "0da4",
	"./eme/Schieberegler/Kernaufgaben/step3_Kernaufgaben_animation.webm": "6689",
	"./eme/Schieberegler/Kernaufgaben/step4_Kernaufgaben.png": "a472",
	"./eme/Schieberegler/Kernaufgaben/step4_Kernaufgaben_animation.mp4": "f5df0",
	"./eme/Schieberegler/Kernaufgaben/step4_Kernaufgaben_animation.webm": "37d5",
	"./eme/Schieberegler/Kernaufgaben/step5_Kernaufgaben.png": "f5e5",
	"./eme/Schieberegler/Kernaufgaben/step5_Kernaufgaben_animation.mp4": "3ce9",
	"./eme/Schieberegler/Kernaufgaben/step5_Kernaufgaben_animation.webm": "708a",
	"./eme/Schieberegler/Kernaufgaben/step6_Kernaufgaben.png": "1dd5",
	"./eme/Schieberegler/Kernaufgaben/step6_Kernaufgaben_animation.mp4": "6dd6",
	"./eme/Schieberegler/Kernaufgaben/step6_Kernaufgaben_animation.webm": "35b4",
	"./eme/Schieberegler/Kernaufgaben/step7_Kernaufgaben.png": "6ac0",
	"./eme/Schieberegler/Kernaufgaben/step7_Kernaufgaben_animation.mp4": "17cf",
	"./eme/Schieberegler/Kernaufgaben/step7_Kernaufgaben_animation.webm": "526b",
	"./eme/Schieberegler/Kernaufgaben/step8_Kernaufgaben.png": "bfc7",
	"./eme/Schieberegler/Kernaufgaben/step8_Kernaufgaben_animation.mp4": "1d19",
	"./eme/Schieberegler/Kernaufgaben/step8_Kernaufgaben_animation.webm": "f10f",
	"./eme/Tafel/0.png": "b330",
	"./eme/Tafel/1.png": "96e9",
	"./eme/Tafel/10.png": "ee39",
	"./eme/Tafel/5.png": "74cb",
	"./eme/Tafel/Quadrataufgaben.png": "7a6b",
	"./eme/Tafel/Verdopplungsaufgaben.png": "3b54",
	"./eme/Tafel/alle.png": "7b53",
	"./eme/Tafel/keine.png": "73c0",
	"./eme/Wuerfel.png": "f0fe",
	"./eme/mia_12mal5.mp4": "d906",
	"./eme/mia_8mal7.mp4": "b454",
	"./epe/1+1-Tafel_A0.png": "3b95",
	"./epe/1+1-Tafel_A1.png": "aa20",
	"./epe/1+1-Tafel_A10.png": "97e1",
	"./epe/1+1-Tafel_A5.png": "df3f",
	"./epe/1+1-Tafel_Verdopplung.png": "100c",
	"./epe/1+1-Tafel_Zerlegung 10.png": "3a7b",
	"./epe/1+1-Tafel_alle.png": "220e",
	"./epe/1+1-Tafel_keine.png": "1ca0",
	"./epe/Aufgabenbeziehungen_Summand.png": "5eaa",
	"./epe/DW_an_Beispielen.png": "98e2",
	"./epe/DW_an_Beispielen.svg": "6f05",
	"./epe/Darstellungsformen.png": "231d",
	"./epe/Darstellungsformen.svg": "cf47",
	"./epe/Gruppen/Fehler/01.png": "17e1",
	"./epe/Gruppen/Fehler/02.png": "9219",
	"./epe/Gruppen/Fehler/03.png": "288c",
	"./epe/Gruppen/Fehler/04.png": "fdef",
	"./epe/Gruppen/Fehler/05.png": "7c5d",
	"./epe/Gruppen/Fehler/06.png": "f236",
	"./epe/Gruppen/Fehler/07.png": "2611",
	"./epe/Gruppen/Fehler/08.png": "85c2",
	"./epe/Gruppen/Fehler/09.png": "2caf",
	"./epe/Gruppen/Grundvorstellungen/01.png": "fcdb",
	"./epe/Gruppen/Grundvorstellungen/02.png": "90df",
	"./epe/Gruppen/Grundvorstellungen/03.png": "adb2",
	"./epe/Gruppen/Grundvorstellungen/04.png": "9ce9",
	"./epe/Gruppen/Grundvorstellungen/05.png": "0131",
	"./epe/Gruppen/Grundvorstellungen/06.png": "031c",
	"./epe/Gruppen/Grundvorstellungen/07.png": "183f",
	"./epe/Gruppen/Grundvorstellungen/08.png": "1ad8",
	"./epe/Gruppen/Grundvorstellungen/09.png": "b5d4",
	"./epe/Gruppen/Grundvorstellungen/10.png": "4185",
	"./epe/Gruppen/Grundvorstellungen/11.png": "2007",
	"./epe/Gruppen/Grundvorstellungen/12.png": "7765",
	"./epe/Pfade/Diagnose/01.png": "932a",
	"./epe/Pfade/Diagnose/02.png": "3006",
	"./epe/Pfade/Diagnose/03.png": "efb0",
	"./epe/Pfade/Diagnose/04.png": "0287",
	"./epe/Pfade/Diagnose/05.png": "f307",
	"./epe/Pfade/Diagnose/06.png": "4faa",
	"./epe/Pfade/Diagnose/07.png": "c287",
	"./epe/Pfade/Diagnose/08.png": "1596",
	"./epe/Pfade/Diagnose/09.png": "82c4",
	"./epe/Pfade/Diagnose/10.png": "fdf5",
	"./epe/Pfade/Diagnose/11.png": "09dd",
	"./epe/Pfade/Diagnose/12.png": "9cb1",
	"./epe/Pfade/Diagnose/13.png": "ea66",
	"./epe/Stempeln/Celine.png": "ece9",
	"./epe/Stempeln/Kim.png": "7f57",
	"./epe/Stempeln/Ravi.png": "8be8",
	"./epe/Stempeln/Sina.png": "860a",
	"./epe/Stempeln/Sina_text.png": "e678",
	"./epe/Stempeln/Tomas.png": "8cce",
	"./explorativeElemente/LernbausteinSortieren/background.png": "62c9",
	"./explorativeElemente/LernbausteinSortieren/error_a.png": "2d45",
	"./explorativeElemente/LernbausteinSortieren/error_b.png": "aa46",
	"./explorativeElemente/LernbausteinSortieren/error_c.png": "b173",
	"./explorativeElemente/LernbausteinSortieren/error_d.png": "ae19",
	"./explorativeElemente/LernbausteinSortieren/error_e.png": "8e39",
	"./explorativeElemente/LernbausteinSortieren/error_f.png": "6790",
	"./faledia_logo.svg": "fdee",
	"./hammer-wrench.svg": "0faa",
	"./hilfevideos/Hilfevideo_LBST_Gruppen.mp4": "8c23",
	"./hilfevideos/Hilfevideo_LBST_Gruppen_B.mp4": "f5a1",
	"./hilfevideos/Hilfevideo_LBST_Pfade.mp4": "0dc4",
	"./hilfevideos/Hilfevideo_LBST_Schieberegler.mp4": "5750",
	"./hilfevideos/Hilfevideo_LBST_Sortieren.mp4": "d4b9",
	"./hilfevideos/Hilfevideo_LBST_Stempeln.mp4": "0508",
	"./hr/DW_Ab1.png": "fc83",
	"./hr/DW_Ab2.png": "25ad",
	"./hr/DW_Ab3.png": "ab9f",
	"./hr/DW_Ab4.png": "77c1",
	"./hr/DW_Ab5.png": "2594",
	"./hr/DW_Ab6.png": "d7df",
	"./hr/DuFTabelle1.png": "b3a3",
	"./hr/DuFTabelle2.png": "b3c0",
	"./hr/DuFTabelle3.png": "debc",
	"./hr/DuFTabelle4.png": "5bff",
	"./hr/Flexibel_Abbildung.png": "28e1",
	"./hr/Gruppen/DW/01.png": "8943",
	"./hr/Gruppen/DW/02.png": "4906",
	"./hr/Gruppen/DW/03.png": "1835",
	"./hr/Gruppen/DW/04.png": "8c0b",
	"./hr/Gruppen/DW/05.png": "ca11",
	"./hr/Gruppen/DW/06.png": "ca8b",
	"./hr/Gruppen/DW/07.png": "bb66",
	"./hr/Gruppen/DW/08.png": "1609",
	"./hr/Gruppen/HR/01.png": "ccaf",
	"./hr/Gruppen/HR/02.png": "ded4",
	"./hr/Gruppen/HR/03.png": "a03a",
	"./hr/Gruppen/HR/04.png": "4893",
	"./hr/Gruppen/HR/05.png": "8f35",
	"./hr/Gruppen/HR/06.png": "e514",
	"./hr/Gruppen/HR/07.png": "5f0c",
	"./hr/Gruppen/HR/08.png": "26df",
	"./hr/Gruppen/HR/09.png": "2c0f",
	"./hr/Gruppen/HR/10.png": "2630",
	"./hr/Gruppen/HR/11.png": "bb5a",
	"./hr/Gruppen/HR/12.png": "b45c",
	"./hr/Pfade/Lea/01.png": "2e9f",
	"./hr/Pfade/Lea/02.png": "82b5",
	"./hr/Pfade/Lea/03.png": "bc8a",
	"./hr/Pfade/Lea/04.png": "83ec",
	"./hr/Pfade/Lea/05.png": "609d",
	"./hr/Pfade/Lea/06.png": "2359",
	"./hr/Pfade/Lea/07.png": "3425",
	"./hr/Pfade/Lea/08.png": "c80c",
	"./hr/Pfade/Lea/09.png": "b75b",
	"./hr/Pfade/Lea/10.png": "d213",
	"./hr/Pfade/Lea/11.png": "9148",
	"./hr/Pfade/Lea/12.png": "bca0",
	"./hr/Pfade/Lea/13.png": "e7e4",
	"./hr/Stempeln/Bsp1/01.png": "c6ad",
	"./hr/Stempeln/Bsp1/02.png": "6684",
	"./hr/Stempeln/Bsp2.png": "b351",
	"./hr/Stempeln/Dia1.png": "b8ec",
	"./hr/Stempeln/Dia2.png": "4025",
	"./hr/StrategienHRTabelle.png": "7271",
	"./hr/halbschriftliche-Subtraktion-Video.mp4": "7830",
	"./hr/halbschriftliches-Rechnen-Hunderterfeld.mp4": "7ecd",
	"./more_topics.jpg": "da9b",
	"./nzr/AllesUndWeiterzaehlen.png": "752c",
	"./nzr/Gruppen/Addition/01.png": "063c",
	"./nzr/Gruppen/Addition/02.png": "f5ff",
	"./nzr/Gruppen/Addition/03.png": "ec00",
	"./nzr/Gruppen/Addition/04.png": "a46d",
	"./nzr/Gruppen/Addition/05.png": "6152",
	"./nzr/Gruppen/Addition/06.png": "e29c",
	"./nzr/Gruppen/Addition/07.png": "758c",
	"./nzr/Gruppen/Addition/08.png": "3e44",
	"./nzr/Gruppen/Addition/09.png": "b0f0",
	"./nzr/Gruppen/Addition/10.png": "123c",
	"./nzr/Gruppen/Subtraktion/01.png": "d0bc",
	"./nzr/Gruppen/Subtraktion/02.png": "d3a8",
	"./nzr/Gruppen/Subtraktion/03.png": "7827",
	"./nzr/Gruppen/Subtraktion/04.png": "4318",
	"./nzr/Gruppen/Subtraktion/05.png": "9617",
	"./nzr/Gruppen/Subtraktion/06.png": "36be",
	"./nzr/Gruppen/Subtraktion/07.png": "2bbf",
	"./nzr/Gruppen/Subtraktion/08.png": "bd94",
	"./nzr/Pfade/Alleszaehlen/01.png": "5255",
	"./nzr/Pfade/Alleszaehlen/02.png": "d386",
	"./nzr/Pfade/Alleszaehlen/03.png": "f68e",
	"./nzr/Pfade/Alleszaehlen/04.png": "07c1",
	"./nzr/Pfade/Alleszaehlen/05.png": "99e6",
	"./nzr/Pfade/Alleszaehlen/06.png": "1e0a",
	"./nzr/Pfade/Alleszaehlen/07.png": "65a8",
	"./nzr/Pfade/Alleszaehlen/08.png": "6477",
	"./nzr/Pfade/Alleszaehlen/09.png": "46c5",
	"./nzr/Pfade/Alleszaehlen/10.png": "8c13",
	"./nzr/Pfade/Alleszaehlen/11.png": "72a9",
	"./nzr/Pfade/Alleszaehlen/12.png": "c85c",
	"./nzr/Pfade/Alleszaehlen/13.png": "fc0f",
	"./nzr/Pfade/Automatisierung/01.png": "106c",
	"./nzr/Pfade/Automatisierung/02.png": "3463",
	"./nzr/Pfade/Automatisierung/03.png": "15c6",
	"./nzr/Pfade/Automatisierung/04.png": "104c",
	"./nzr/Pfade/Automatisierung/05.png": "6306",
	"./nzr/Pfade/Automatisierung/06.png": "c956",
	"./nzr/Pfade/Automatisierung/07.png": "d4d5",
	"./nzr/Pfade/Automatisierung/08.png": "12c8",
	"./nzr/Pfade/Automatisierung/09.png": "c967",
	"./nzr/Pfade/Automatisierung/10.png": "47fa",
	"./nzr/Pfade/Automatisierung/11.png": "5210",
	"./nzr/Pfade/Automatisierung/12.png": "1d74",
	"./nzr/Pfade/Weiterzaehlen/01.mp3": "31fa",
	"./nzr/Pfade/Weiterzaehlen/02.png": "6dce",
	"./nzr/Pfade/Weiterzaehlen/03.png": "1136",
	"./nzr/Pfade/Weiterzaehlen/04.png": "015f",
	"./nzr/Pfade/Weiterzaehlen/05.png": "dcd4",
	"./nzr/Pfade/Weiterzaehlen/06.png": "3ee4",
	"./nzr/Pfade/Weiterzaehlen/07.png": "01fd",
	"./nzr/Pfade/Weiterzaehlen/08.png": "82c7",
	"./nzr/Pfade/Weiterzaehlen/09.png": "9f1b",
	"./nzr/Pfade/Weiterzaehlen/10.png": "53b7",
	"./nzr/Pfade/Weiterzaehlen/11.png": "e35c",
	"./nzr/Pfade/Weiterzaehlen/12.png": "6f1b",
	"./nzr/Pfade/Weiterzaehlen/13.png": "a761",
	"./nzr/Rechenstrategien.png": "4280",
	"./nzr/Schieberegler/Step0.mp4": "df94",
	"./nzr/Schieberegler/Step0.png": "0dce",
	"./nzr/Schieberegler/Step0.webm": "932b",
	"./nzr/Schieberegler/Step1.mp4": "4d0f",
	"./nzr/Schieberegler/Step1.png": "b106",
	"./nzr/Schieberegler/Step1.webm": "7cc1",
	"./nzr/Schieberegler/Step2.mp4": "f87e",
	"./nzr/Schieberegler/Step2.png": "fa1c",
	"./nzr/Schieberegler/Step2.webm": "763b",
	"./nzr/Schipper.png": "9fe7",
	"./nzr/Schipper_a0.png": "b725",
	"./nzr/Schipper_a1.png": "fbee",
	"./nzr/Schipper_a2.png": "a7e0",
	"./nzr/Schipper_a3.png": "f18b",
	"./nzr/Schipper_a4.png": "a6a7",
	"./nzr/Schipper_a5.png": "19ab",
	"./nzr/TeilGanzes.png": "6451",
	"./nzr/TeilGanzes4Konstant.png": "ac3e",
	"./nzr/TeilGanzes5Diff.png": "0aeb",
	"./nzr/TeilGanzes5Konstant.png": "799f",
	"./nzr/TeilGanzes6Konstant.png": "c13b",
	"./operationsverstaendnis.jpg": "5acc",
	"./ov/Pfade_Fynn/Pfade_Fynn_1.png": "ed40",
	"./ov/Pfade_Fynn/Pfade_Fynn_10.png": "9013",
	"./ov/Pfade_Fynn/Pfade_Fynn_11.png": "ca85",
	"./ov/Pfade_Fynn/Pfade_Fynn_12.png": "4e2a",
	"./ov/Pfade_Fynn/Pfade_Fynn_13.png": "a3c8",
	"./ov/Pfade_Fynn/Pfade_Fynn_2.png": "9f8e",
	"./ov/Pfade_Fynn/Pfade_Fynn_3.png": "cd8b",
	"./ov/Pfade_Fynn/Pfade_Fynn_4.png": "2074",
	"./ov/Pfade_Fynn/Pfade_Fynn_5.png": "a66e",
	"./ov/Pfade_Fynn/Pfade_Fynn_6.png": "0a36",
	"./ov/Pfade_Fynn/Pfade_Fynn_7.png": "57e5",
	"./ov/Pfade_Fynn/Pfade_Fynn_8.png": "5d28",
	"./ov/Pfade_Fynn/Pfade_Fynn_9.png": "a259",
	"./ov/Stempeln_Diagnose/Diagnose Clarissa_neu_Stufe01.mp4": "9e0a",
	"./ov/Stempeln_Diagnose/Diagnose Clarissa_neu_Stufe02.mp4": "e6df",
	"./ov/Stempeln_Diagnose/Diagnose John_neu_Stufe01.mp4": "8d45",
	"./ov/Stempeln_Diagnose/Diagnose John_neu_Stufe02.mp4": "8cf0",
	"./ov/Stempeln_Diagnose/Diagnose Ninon_neu_Stufe01.mp4": "88d8",
	"./ov/Stempeln_Diagnose/Diagnose Ninon_neu_Stufe02.mp4": "ef98",
	"./ov/Stempeln_Hintergrund/OVI_OABH2_1_Stufe02.mp3": "7035",
	"./ov/Stempeln_Hintergrund/OVI_OABH2_2_Stufe02.mp3": "2e9e",
	"./ov/check_hintergrund.jpg": "72ae",
	"./ov/diagnoseUndFoerderung_hintergrund.jpg": "cec9",
	"./ov/operationsverstaendnis_hintergrund.jpg": "338b",
	"./ove/Gruppen_Diagnose/gruppen_diagnose_01.png": "d0fc",
	"./ove/Gruppen_Diagnose/gruppen_diagnose_02.png": "18fe",
	"./ove/Gruppen_Diagnose/gruppen_diagnose_03.png": "f7e6",
	"./ove/Gruppen_Diagnose/gruppen_diagnose_04.png": "053c",
	"./ove/Gruppen_Diagnose/gruppen_diagnose_05.png": "e2ec",
	"./ove/Gruppen_Diagnose/gruppen_diagnose_06.png": "afb8",
	"./ove/Gruppen_Diagnose/gruppen_diagnose_07.png": "d65b",
	"./ove/Gruppen_Diagnose/gruppen_diagnose_08.png": "d32a",
	"./ove/Gruppen_Diagnose/gruppen_diagnose_09.png": "99cf",
	"./ove/ODWH_2_ODWH1_V2/ODWH1_1.png": "694f",
	"./ove/ODWH_2_ODWH1_V2/ODWH1_2.png": "814a",
	"./ove/ODWH_2_ODWH1_V2/ODWH1_3.png": "0dbd",
	"./ove/ODWH_2_ODWH1_V2/ODWH1_4.png": "bb4c",
	"./ove/ODWH_2_ODWH1_V2/ODWH1_5.png": "d437",
	"./ove/ODWH_2_ODWH1_V2/ODWH1_6.png": "bb57",
	"./ove/ODWH_2_ODWH1_V2/ODWH1_7.png": "f517",
	"./ove/ODWH_2_ODWH2_V2/odwh2_v2_element_01.png": "d18e",
	"./ove/ODWH_2_ODWH2_V2/odwh2_v2_element_02.png": "2de4",
	"./ove/ODWH_2_ODWH2_V2/odwh2_v2_element_03.png": "d298",
	"./ove/ODWH_2_ODWH2_V2/odwh2_v2_element_04.png": "835c",
	"./ove/ODWH_2_ODWH2_V2/odwh2_v2_element_05.png": "ac8e",
	"./ove/ODWH_2_ODWH2_V2/odwh2_v2_element_06.png": "dc99",
	"./ove/ODWH_2_ODWH2_V2/odwh2_v2_element_07.png": "3e35",
	"./ove/ODWH_2_ODWH2_V2/odwh2_v2_element_08.png": "df04",
	"./ove/ODWH_2_ODWH3_V2/odwh3_v2_element_01.png": "be6e",
	"./ove/ODWH_2_ODWH3_V2/odwh3_v2_element_02.png": "2f05",
	"./ove/ODWH_2_ODWH3_V2/odwh3_v2_element_03.png": "de42",
	"./ove/ODWH_2_ODWH3_V2/odwh3_v2_element_04.png": "967f",
	"./ove/ODWH_2_ODWH3_V2/odwh3_v2_element_05.png": "5b9c",
	"./ove/ODWH_2_ODWH3_V2/odwh3_v2_element_06.png": "beae",
	"./ove/ODWH_2_ODWH3_V2/odwh3_v2_element_07.png": "e023",
	"./ove/ODWH_2_ODWH4_V2/ODWH4_1.png": "d36e",
	"./ove/ODWH_2_ODWH4_V2/ODWH4_2.png": "72a4",
	"./ove/ODWH_2_ODWH4_V2/ODWH4_3.png": "8c56",
	"./ove/ODWH_2_ODWH4_V2/ODWH4_4.png": "c547",
	"./ove/ODWH_2_ODWH4_V2/ODWH4_5.png": "e722",
	"./ove/ODWH_2_ODWH4_V2/ODWH4_6.png": "a422",
	"./ove/ODWH_2_ODWH4_V2/ODWH4_7.png": "7fa6",
	"./ove/OGVH_Gruppen/OGVH_1.png": "3139",
	"./ove/OGVH_Gruppen/OGVH_10.png": "8676",
	"./ove/OGVH_Gruppen/OGVH_11.png": "af4e",
	"./ove/OGVH_Gruppen/OGVH_12.png": "73ef",
	"./ove/OGVH_Gruppen/OGVH_13.png": "a8fc",
	"./ove/OGVH_Gruppen/OGVH_14.png": "b520",
	"./ove/OGVH_Gruppen/OGVH_15.png": "9152",
	"./ove/OGVH_Gruppen/OGVH_16.png": "915b",
	"./ove/OGVH_Gruppen/OGVH_2.png": "89e9",
	"./ove/OGVH_Gruppen/OGVH_3.png": "4baf",
	"./ove/OGVH_Gruppen/OGVH_4.png": "6e50",
	"./ove/OGVH_Gruppen/OGVH_5.png": "f08f",
	"./ove/OGVH_Gruppen/OGVH_6.png": "098a",
	"./ove/OGVH_Gruppen/OGVH_7.png": "2b90",
	"./ove/OGVH_Gruppen/OGVH_8.png": "d2ad",
	"./ove/OGVH_Gruppen/OGVH_9.png": "7220",
	"./ove/Stempeln/OABD_2_1.png": "32a3",
	"./ove/Stempeln/ODWD_2/ODWD_2_1.png": "795d",
	"./ove/Stempeln/ODWD_2/ODWD_2_2.png": "a1ea",
	"./ove/Stempeln/OGVD_2/OGVD_2_1.png": "165c",
	"./ove/Stempeln/OGVD_2/OGVD_2_1_A.png": "02ff",
	"./ove/Stempeln/OGVD_2/OGVD_2_1_D.png": "46b2",
	"./ove/Stempeln/mia_11plus178.mp4": "92ce",
	"./ove/Stempeln/mia_12mal5.mp4": "f4ba",
	"./ove/Stempeln/mia_13plus9.mp4": "f124",
	"./ove/Stempeln/mia_19plus21.mp4": "de08",
	"./ove/Stempeln/mia_8mal7.mp4": "f0a4",
	"./ove/ove_4plus3.png": "864d",
	"./ove/ove_darstellungsformen.png": "2057",
	"./ove/ove_gesetzestabelle.png": "4dc7",
	"./ovi/Diagnose/Diagnose Clarissa_neu.mp4": "0c38",
	"./ovi/Diagnose/Diagnose John_neu.mp4": "436e",
	"./ovi/Diagnose/Diagnose Ninon_neu.mp4": "e8b6",
	"./ovi/Diagnose/diagnose_2mal7.png": "2eb7",
	"./ovi/Diagnose/diagnose_2mal9.png": "2ba2",
	"./ovi/Diagnose/diagnose_3mal5.png": "57e4",
	"./ovi/Diagnose/diagnose_4mal6.png": "8c95",
	"./ovi/Diagnose/diagnose_claas.png": "3337",
	"./ovi/Diagnose/diagnose_fotokartei.png": "3186",
	"./ovi/Diagnose/diagnose_niklas.png": "6208",
	"./ovi/Diagnose/diagnose_suna.png": "fc4c",
	"./ovi/Diagnose/diagnose_zahlenstrahl.png": "97da",
	"./ovi/Drehbuecher/OVI_OABH2_1.mp3": "41f9",
	"./ovi/Drehbuecher/OVI_OABH2_2.mp3": "4107",
	"./ovi/ODWH 1_neu.mp4": "7219",
	"./ovi/ODWH 2_neu.mp4": "c27c",
	"./ovi/ODWH 3_neu.mp4": "6d91",
	"./stellenwertverstaendnis.jpg": "1489",
	"./swv/Pfade_Tabea/Pfade_Tabea_1.png": "5fea",
	"./swv/Pfade_Tabea/Pfade_Tabea_10.png": "7a43",
	"./swv/Pfade_Tabea/Pfade_Tabea_11.png": "8fa1",
	"./swv/Pfade_Tabea/Pfade_Tabea_12.png": "0b5d",
	"./swv/Pfade_Tabea/Pfade_Tabea_13.png": "8492",
	"./swv/Pfade_Tabea/Pfade_Tabea_2.png": "d546",
	"./swv/Pfade_Tabea/Pfade_Tabea_3.png": "3336",
	"./swv/Pfade_Tabea/Pfade_Tabea_4.png": "763d",
	"./swv/Pfade_Tabea/Pfade_Tabea_5.png": "a3e3",
	"./swv/Pfade_Tabea/Pfade_Tabea_6.png": "556e",
	"./swv/Pfade_Tabea/Pfade_Tabea_7.png": "67fa",
	"./swv/Pfade_Tabea/Pfade_Tabea_8.png": "5d04",
	"./swv/Pfade_Tabea/Pfade_Tabea_9.png": "e25b",
	"./swv/check_hintergrund.jpg": "8ae6",
	"./swv/diagnoseUndFoerderung_hintergrund.jpg": "62ee",
	"./swv/stellenwertverstaendnis_hintergrund.jpg": "3c51",
	"./swve/1_SEBH_1_4er_System/mp4/step1_animation.mp4": "958a",
	"./swve/1_SEBH_1_4er_System/mp4/step2_animation.mp4": "3392",
	"./swve/1_SEBH_1_4er_System/mp4/step3_animation.mp4": "9807",
	"./swve/1_SEBH_1_4er_System/mp4/step4_animation.mp4": "8f10",
	"./swve/1_SEBH_1_4er_System/mp4/step5_animation.mp4": "5bd8",
	"./swve/1_SEBH_1_4er_System/mp4/step6_animation.mp4": "d4b1",
	"./swve/1_SEBH_1_4er_System/mp4/step7_animation.mp4": "fd79",
	"./swve/1_SEBH_1_4er_System/mp4/step8_animation.mp4": "9fed",
	"./swve/1_SEBH_1_4er_System/png/step0.png": "adf3",
	"./swve/1_SEBH_1_4er_System/png/step1.png": "980d",
	"./swve/1_SEBH_1_4er_System/png/step2.png": "966f",
	"./swve/1_SEBH_1_4er_System/png/step3.png": "5091",
	"./swve/1_SEBH_1_4er_System/png/step4.png": "df43",
	"./swve/1_SEBH_1_4er_System/png/step5.png": "a9d1",
	"./swve/1_SEBH_1_4er_System/png/step6.png": "d7bc",
	"./swve/1_SEBH_1_4er_System/png/step7.png": "f960",
	"./swve/1_SEBH_1_4er_System/png/step8.png": "dda3",
	"./swve/1_SEBH_1_4er_System/webm/step1_animation.webm": "0c4b",
	"./swve/1_SEBH_1_4er_System/webm/step2_animation.webm": "3a02",
	"./swve/1_SEBH_1_4er_System/webm/step3_animation.webm": "3146",
	"./swve/1_SEBH_1_4er_System/webm/step4_animation.webm": "ac69",
	"./swve/1_SEBH_1_4er_System/webm/step5_animation.webm": "59ca",
	"./swve/1_SEBH_1_4er_System/webm/step6_animation.webm": "fbec",
	"./swve/1_SEBH_1_4er_System/webm/step7_animation.webm": "2173",
	"./swve/1_SEBH_1_4er_System/webm/step8_animation.webm": "d890",
	"./swve/2_SEBH_1_5er_System/mp4/step1_animation.mp4": "1325",
	"./swve/2_SEBH_1_5er_System/mp4/step2_animation.mp4": "a418",
	"./swve/2_SEBH_1_5er_System/mp4/step3_animation.mp4": "7027",
	"./swve/2_SEBH_1_5er_System/mp4/step4_animation.mp4": "ba77",
	"./swve/2_SEBH_1_5er_System/mp4/step5_animation.mp4": "76f5",
	"./swve/2_SEBH_1_5er_System/mp4/step6_animation.mp4": "5a9f",
	"./swve/2_SEBH_1_5er_System/png/step0.png": "276a",
	"./swve/2_SEBH_1_5er_System/png/step1.png": "04d1",
	"./swve/2_SEBH_1_5er_System/png/step2.png": "38e9",
	"./swve/2_SEBH_1_5er_System/png/step3.png": "f853",
	"./swve/2_SEBH_1_5er_System/png/step4.png": "103e",
	"./swve/2_SEBH_1_5er_System/png/step5.png": "2ff5",
	"./swve/2_SEBH_1_5er_System/png/step6.png": "5e91",
	"./swve/2_SEBH_1_5er_System/webm/step1_animation.webm": "5378",
	"./swve/2_SEBH_1_5er_System/webm/step2_animation.webm": "7bf4",
	"./swve/2_SEBH_1_5er_System/webm/step3_animation.webm": "2400",
	"./swve/2_SEBH_1_5er_System/webm/step4_animation.webm": "72d2",
	"./swve/2_SEBH_1_5er_System/webm/step5_animation.webm": "b455",
	"./swve/2_SEBH_1_5er_System/webm/step6_animation.webm": "7227",
	"./swve/3_SEBH_1_3er_System/mp4/step10_animation.mp4": "f230",
	"./swve/3_SEBH_1_3er_System/mp4/step1_animation.mp4": "9519",
	"./swve/3_SEBH_1_3er_System/mp4/step2_animation.mp4": "eb29",
	"./swve/3_SEBH_1_3er_System/mp4/step3_animation.mp4": "3b19",
	"./swve/3_SEBH_1_3er_System/mp4/step4_animation.mp4": "4a88",
	"./swve/3_SEBH_1_3er_System/mp4/step5_animation.mp4": "4183",
	"./swve/3_SEBH_1_3er_System/mp4/step6_animation.mp4": "f3e2",
	"./swve/3_SEBH_1_3er_System/mp4/step7_animation.mp4": "c709",
	"./swve/3_SEBH_1_3er_System/mp4/step8_animation.mp4": "cbda",
	"./swve/3_SEBH_1_3er_System/mp4/step9_animation.mp4": "2baa",
	"./swve/3_SEBH_1_3er_System/png/step0.png": "7e16",
	"./swve/3_SEBH_1_3er_System/png/step1.png": "33b8",
	"./swve/3_SEBH_1_3er_System/png/step10.png": "5c1a",
	"./swve/3_SEBH_1_3er_System/png/step2.png": "4121",
	"./swve/3_SEBH_1_3er_System/png/step3.png": "6922",
	"./swve/3_SEBH_1_3er_System/png/step4.png": "5a3e",
	"./swve/3_SEBH_1_3er_System/png/step5.png": "5358",
	"./swve/3_SEBH_1_3er_System/png/step6.png": "2f38",
	"./swve/3_SEBH_1_3er_System/png/step7.png": "1cc7",
	"./swve/3_SEBH_1_3er_System/png/step8.png": "f567",
	"./swve/3_SEBH_1_3er_System/png/step9.png": "7e77",
	"./swve/3_SEBH_1_3er_System/webm/step10_animation.webm": "245f",
	"./swve/3_SEBH_1_3er_System/webm/step1_animation.webm": "4a44",
	"./swve/3_SEBH_1_3er_System/webm/step2_animation.webm": "7cec",
	"./swve/3_SEBH_1_3er_System/webm/step3_animation.webm": "dde3",
	"./swve/3_SEBH_1_3er_System/webm/step4_animation.webm": "2045",
	"./swve/3_SEBH_1_3er_System/webm/step5_animation.webm": "f5ba",
	"./swve/3_SEBH_1_3er_System/webm/step6_animation.webm": "871c",
	"./swve/3_SEBH_1_3er_System/webm/step7_animation.webm": "50ee",
	"./swve/3_SEBH_1_3er_System/webm/step8_animation.webm": "e78e",
	"./swve/3_SEBH_1_3er_System/webm/step9_animation.webm": "4c1b",
	"./swve/Einzeldiagnose/Einzeldiagnose_Rechnung_Clara.png": "d74e",
	"./swve/Einzeldiagnose/Einzeldiagnose_Rechnung_Marie.png": "dbbe",
	"./swve/Einzeldiagnose/Einzeldiagnose_Rechnung_Taifun.png": "f93d",
	"./swve/Einzeldiagnose/Einzeldiagnose_Rechnung_Taifun_A.png": "5f4b",
	"./swve/Einzeldiagnose/Einzeldiagnose_Rechnung_Taifun_B.png": "772d",
	"./swve/Einzeldiagnose/Einzeldiagnose_Rechnung_Taifun_C.png": "66e0",
	"./swve/Gruppendiagnose/Fehlertyp1_Dok1.jpg": "fa64",
	"./swve/Gruppendiagnose/Fehlertyp1_Dok2.jpg": "320c",
	"./swve/Gruppendiagnose/Fehlertyp1_Dok3.jpg": "218b",
	"./swve/Gruppendiagnose/Fehlertyp2_Dok1.jpg": "ce48",
	"./swve/Gruppendiagnose/Fehlertyp2_Dok2.jpg": "6c39",
	"./swve/Gruppendiagnose/Fehlertyp2_Dok3.jpg": "a8e3",
	"./swve/Gruppendiagnose/Fehlertyp3_Dok1.jpg": "358c",
	"./swve/Gruppendiagnose/Fehlertyp3_Dok2.jpg": "212f",
	"./swve/Gruppendiagnose/Fehlertyp3_Dok3.jpg": "a08d",
	"./swve/Gruppendiagnose/Fehlertyp4_Dok1.jpg": "dee3",
	"./swve/Gruppendiagnose/Fehlertyp4_Dok2.jpg": "e5d2",
	"./swve/Gruppendiagnose/Fehlertyp4_Dok3.jpg": "506a",
	"./swve/Gruppendiagnose/Fehlertyp5_Dok1.jpg": "bb25",
	"./swve/Gruppendiagnose/Fehlertyp5_Dok2.jpg": "3f49",
	"./swve/Gruppendiagnose/Fehlertyp5_Dok3.jpg": "e760",
	"./swve/SDWH2_10er/2030_1.jpg": "3552",
	"./swve/SDWH2_10er/2030_2.jpg": "e132",
	"./swve/SDWH2_10er/2030_3.jpg": "2589",
	"./swve/SDWH2_10er/2030_4.jpg": "df05",
	"./swve/SDWH2_10er/203_1.jpg": "5c7a",
	"./swve/SDWH2_10er/203_2.jpg": "92bd",
	"./swve/SDWH2_10er/203_3.jpg": "93dc",
	"./swve/SDWH2_10er/203_4.jpg": "f92e",
	"./swve/SDWH2_10er/223_1.jpg": "8dba",
	"./swve/SDWH2_10er/223_2.jpg": "2ad2",
	"./swve/SDWH2_10er/223_3.jpg": "748b",
	"./swve/SDWH2_10er/223_4.jpg": "1cf1",
	"./swve/SDWH2_10er/32_1.jpg": "3204",
	"./swve/SDWH2_10er/32_2.jpg": "06a9",
	"./swve/SDWH2_10er/32_3.jpg": "5545",
	"./swve/SDWH2_10er/32_4.jpg": "70e7",
	"./swve/SDWH2_5er/1233_1.jpg": "72bc",
	"./swve/SDWH2_5er/1233_2.jpg": "1532",
	"./swve/SDWH2_5er/1233_3.jpg": "380f",
	"./swve/SDWH2_5er/1233_4.jpg": "755c",
	"./swve/SDWH2_5er/302_1.jpg": "75e6",
	"./swve/SDWH2_5er/302_2.jpg": "4089",
	"./swve/SDWH2_5er/302_3.jpg": "c992",
	"./swve/SDWH2_5er/302_4.jpg": "a61e",
	"./swve/SDWH2_5er/320_1.jpg": "fb73",
	"./swve/SDWH2_5er/320_2.jpg": "4cf5",
	"./swve/SDWH2_5er/320_3.jpg": "9a69",
	"./swve/SDWH2_5er/320_4.jpg": "4bf3",
	"./swve/SDWH2_5er/322_1.jpg": "e9e8",
	"./swve/SDWH2_5er/322_2.jpg": "9635",
	"./swve/SDWH2_5er/322_3.jpg": "1138",
	"./swve/SDWH2_5er/322_4.jpg": "7940",
	"./swve/SSZH_2_1/sszh_2_1_1.png": "c99a",
	"./swve/SSZH_2_1/sszh_2_1_2.png": "38c7",
	"./swve/SSZH_2_1/sszh_2_1_3.png": "263b",
	"./swve/SSZH_2_1/sszh_2_1_4.png": "622a",
	"./swve/swve_darstellungswechsel.png": "d118",
	"./swve/swve_einer.png": "0029",
	"./swve/swve_fort_buendeln.png": "85e9",
	"./swve/swve_voll_buendelung.png": "f692",
	"./swve/swve_zehner.png": "71ed",
	"./swvi/3er-System um 4 weiterzählen_201103_YB.mp4": "0ee9",
	"./swvi/4er-System um 1 weiterzählen_201103_YB.mp4": "c0f4",
	"./swvi/5er-System um 2 weiterzählen_201103_YB.mp4": "9024",
	"./swvi/Gruppendiagnose/SWV-I_Gruppendiagnose_1_Probleme_mit_der_0.mp3": "6d57",
	"./swvi/Gruppendiagnose/SWV-I_Gruppendiagnose_2_Fehlende_Bündelung.mp3": "dc2c",
	"./swvi/Gruppendiagnose/SWV-I_Gruppendiagnose_3_Falsche_Bündelungseinheit.mp3": "77bf",
	"./swvi/Gruppendiagnose/SWV-I_Gruppendiagnose_4_Falsche_Reihenfolge_der_Stellenwerte.mp3": "8bbb",
	"./swvi/SDWH2_5er/SWV-I_DW_1_Stellenwerttafel.mp3": "1117",
	"./swvi/SDWH2_5er/SWV-I_DW_2_Punktebild.mp3": "7576",
	"./swvi/SDWH2_5er/SWV-I_DW_3_Oehlsche_Schreibweise.mp3": "1511",
	"./swvi/SDWH2_5er/SWV-I_DW_4_Dienes-Material.mp3": "bac7",
	"./swvi/SWV-I_Zahlen_sortieren_201113.mp4": "88b6",
	"./zr/Gruppen_Fehler/Element10_Fehler_Ziffernrechnen.png": "498c",
	"./zr/Gruppen_Fehler/Element11_Fehler_Ziffernrechnen.png": "9ce2",
	"./zr/Gruppen_Fehler/Element12_Fehler_Ziffernrechnen.png": "6ca5",
	"./zr/Gruppen_Fehler/Element1_Fehler_Ziffernrechnen.png": "4def",
	"./zr/Gruppen_Fehler/Element2_Fehler_Ziffernrechnen.png": "de4e",
	"./zr/Gruppen_Fehler/Element3_Fehler_Ziffernrechnen.png": "b1d3",
	"./zr/Gruppen_Fehler/Element4_Fehler_Ziffernrechnen.png": "1fb7",
	"./zr/Gruppen_Fehler/Element5_Fehler_Ziffernrechnen.png": "5e5c",
	"./zr/Gruppen_Fehler/Element6_Fehler_Ziffernrechnen.png": "313a",
	"./zr/Gruppen_Fehler/Element7_Fehler_Ziffernrechnen.png": "5258",
	"./zr/Gruppen_Fehler/Element8_Fehler_Ziffernrechnen.png": "979c",
	"./zr/Gruppen_Fehler/Element9_Fehler_Ziffernrechnen.png": "5b30",
	"./zr/Gruppen_flexibel/01.png": "1c40",
	"./zr/Gruppen_flexibel/02.png": "aab0",
	"./zr/Gruppen_flexibel/03.png": "40c7",
	"./zr/Gruppen_flexibel/04.png": "b6ba",
	"./zr/Gruppen_flexibel/05.png": "cc98",
	"./zr/Gruppen_flexibel/06.png": "0385",
	"./zr/Gruppen_flexibel/07.png": "6e2d",
	"./zr/Gruppen_flexibel/08.png": "d0a2",
	"./zr/Gruppen_flexibel/09.png": "2b13",
	"./zr/Ordnen/01.png": "a07a",
	"./zr/Ordnen/02.png": "0214",
	"./zr/Ordnen/03.png": "1afd",
	"./zr/Ordnen/04.png": "ed0c",
	"./zr/Stempeln_Herleitung/01.png": "befb",
	"./zr/Stempeln_Herleitung/02.png": "bc34",
	"./zr/Stempeln_Herleitung/03.png": "4bba",
	"./zr/Stempeln_Herleitung/04.png": "5777",
	"./zr/Stempeln_Herleitung/05.png": "2aeb",
	"./zr/Stempeln_Herleitung/06.png": "b13d",
	"./zr/Stempeln_Verfahren_Addition.png": "8cf2",
	"./zr/verfahrensweisen_1.png": "cda6",
	"./zr/verfahrensweisen_2.png": "8d30",
	"./zr/verfahrensweisen_3.png": "ce57",
	"./zv/Gruppen/zaehlfehler/01.png": "b267",
	"./zv/Gruppen/zaehlfehler/02.png": "9aba",
	"./zv/Gruppen/zaehlfehler/03.png": "f9b0",
	"./zv/Gruppen/zaehlfehler/04.png": "0227",
	"./zv/Gruppen/zaehlfehler/05.png": "1a76",
	"./zv/Gruppen/zaehlfehler/06.png": "bd0e",
	"./zv/Gruppen/zaehlfehler/07.png": "058f",
	"./zv/Gruppen/zaehlfehler/08.png": "5c42",
	"./zv/Gruppen/zaehlfehler/09.png": "7a7e",
	"./zv/Gruppen/zp/01.png": "cdb6",
	"./zv/Gruppen/zp/02.png": "a5b4",
	"./zv/Gruppen/zp/03.png": "a89f",
	"./zv/Gruppen/zp/04.png": "e6db",
	"./zv/Gruppen/zp/05.png": "bdf8",
	"./zv/Gruppen/zp/aufgabe_alt_1.png": "0468",
	"./zv/Gruppen/zp/aufgabe_alt_2.png": "f2ed",
	"./zv/Gruppen/zp/aufgabe_alt_3.png": "b5e9",
	"./zv/Pfade/darstellungsvernetzung/01.png": "c8c4",
	"./zv/Pfade/darstellungsvernetzung/02.png": "8516",
	"./zv/Pfade/darstellungsvernetzung/03.png": "0e19",
	"./zv/Pfade/darstellungsvernetzung/04.png": "f0a3",
	"./zv/Pfade/darstellungsvernetzung/05.png": "9dff",
	"./zv/Pfade/darstellungsvernetzung/06.png": "c42e",
	"./zv/Pfade/darstellungsvernetzung/07.png": "63d3",
	"./zv/Pfade/darstellungsvernetzung/08.png": "ca7c",
	"./zv/Pfade/darstellungsvernetzung/09.png": "2072",
	"./zv/Pfade/darstellungsvernetzung/10.png": "9d3b",
	"./zv/Pfade/darstellungsvernetzung/11.png": "5af8",
	"./zv/Pfade/darstellungsvernetzung/12.png": "4474",
	"./zv/Pfade/darstellungsvernetzung/13.png": "9caf",
	"./zv/Pfade/zahlaspekte/01.png": "ba777",
	"./zv/Pfade/zahlaspekte/02.png": "fecc",
	"./zv/Pfade/zahlaspekte/03.png": "cea5",
	"./zv/Pfade/zahlaspekte/04.png": "474d",
	"./zv/Pfade/zahlaspekte/05.png": "4088",
	"./zv/Pfade/zahlaspekte/06.png": "6e7d",
	"./zv/Pfade/zahlaspekte/07.png": "77b9",
	"./zv/Pfade/zahlaspekte/08.png": "64c4",
	"./zv/Pfade/zahlaspekte/09.png": "6c28",
	"./zv/Pfade/zahlaspekte/10.png": "eb85",
	"./zv/Pfade/zahlaspekte/11.png": "5fd7",
	"./zv/Pfade/zahlaspekte/12.png": "c0c4",
	"./zv/Pfade/zahlaspekte/13.png": "c90d",
	"./zv/Schieberegler/step0_Brueche.png": "01dd",
	"./zv/Schieberegler/step1_animation_Brueche.mp4": "9475",
	"./zv/Schieberegler/step1_animation_Brueche.webm": "c32a",
	"./zv/Schieberegler/step2_animation_Brueche.mp4": "1e0a9",
	"./zv/Schieberegler/step2_animation_Brueche.webm": "e55f",
	"./zv/Schieberegler/step3_animation_Brueche.mp4": "ea9b",
	"./zv/Schieberegler/step3_animation_Brueche.webm": "015e",
	"./zv/Schieberegler/step4_animation_Brueche.mp4": "4d77",
	"./zv/Schieberegler/step4_animation_Brueche.webm": "45e5",
	"./zv/Schieberegler/step5_animation_Brueche.mp4": "bc4c",
	"./zv/Schieberegler/step5_animation_Brueche.webm": "a448",
	"./zv/Schieberegler/step6_animation_Brueche.mp4": "ff5a",
	"./zv/Schieberegler/step6_animation_Brueche.webm": "0516",
	"./zv/Sortieren/material/01.png": "1b9a",
	"./zv/Sortieren/material/02.png": "3f9b",
	"./zv/Sortieren/material/03.png": "599f",
	"./zv/Sortieren/material/04.png": "9959",
	"./zv/Sortieren/zaehlen/01.png": "aeba",
	"./zv/Sortieren/zaehlen/02.png": "f2cb",
	"./zv/Sortieren/zaehlen/03.png": "af40",
	"./zv/Sortieren/zaehlen/04.png": "e0a2",
	"./zv/Sortieren/zaehlen/05.png": "d208",
	"./zv/Stempeln/Punktebild_11.mp4": "7556",
	"./zv/Stempeln/Punktebild_21.mp4": "873a",
	"./zv/Stempeln/Punktebild_35.mp4": "8124",
	"./zv/Stempeln/ZV.png": "74f0",
	"./zv/darstellungen.png": "7bec",
	"./zv/zusammenhaenge.png": "1523"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "1771";